var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.tabsClasss }, [
    _c("div", { staticClass: "mku-tabs__head" }, [
      _c(
        "ul",
        { staticClass: "mku-tabs__head-nav" },
        _vm._l(_vm.panes, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              class: _vm.navItemClasss(item),
              on: {
                click: function($event) {
                  return _vm.handleLabelClick(item)
                }
              }
            },
            [
              item.icon
                ? _c("i", {
                    class: [
                      "mku-icon",
                      "mku-tabs__nav-icon",
                      "mku-icon-" + item.icon
                    ]
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "mku-tab__label" }, [
                _vm._v(_vm._s(item.label))
              ]),
              _vm._v(" "),
              _vm.closable
                ? _c("i", {
                    staticClass: "mku-icon mku-icon-error",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.handleClose(item)
                      }
                    }
                  })
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mku-tabs__head-right" }, [_vm._t("extra")], 2),
      _vm._v(" "),
      _vm.type === "line"
        ? _c("span", {
            staticClass: "mku-tabs__underline",
            style: _vm.underlineStyle
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mku-tabs__content" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }